import React from "react";
import Header from "../components/layout/Header";
import MainContainer from "../components/main/MainContainer";

const Main: React.FC = () => {
  return (
    <>
      <Header />
      <MainContainer />
    </>
  );
};

export default Main;
